<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.41895 21.5815L21.5812 9.41931" stroke="black" stroke-width="1.8" stroke-linecap="round"/>
    <path d="M9.41895 9.41919L21.5812 21.5814" stroke="black" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'cross-icon'
}
</script>

<style scoped>

</style>
